export const getRecaptchaToken = async (action: string) =>
  new Promise<string>((resolve) => {
    grecaptcha.ready(() => {
      grecaptcha.execute(process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || "", { action }).then(resolve);
    });
  });
